import async from "./components/Async";

// All pages that rely on 3rd party components (other than MUI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";
import DocLayout from "./layouts/Doc";

// Guards
import AuthGuard from "./components/guards/AuthGuard";

// Auth components
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import ResetPassword from "./pages/auth/ResetPassword";
import Page404 from "./pages/auth/Page404";
import Page500 from "./pages/auth/Page500";
import ACTControl from "./pages/auth/ACT-Control.js";
import Register from "./pages/auth/Register";
import InsertPassword from "./pages/auth/reset-password/InsertPassword.js";
import OperationSuccess from "./pages/public/OperationSuccess";
import OperationFailed from "./pages/public/OperationFailed";

// Components
import Accordion from "./pages/components/Accordion";
import Alerts from "./pages/components/Alerts";
import Avatars from "./pages/components/Avatars";
import Badges from "./pages/components/Badges";
import Buttons from "./pages/components/Buttons";
import Cards from "./pages/components/Cards";
import Chips from "./pages/components/Chips";
import Dialogs from "./pages/components/Dialogs";
import Lists from "./pages/components/Lists";
import Menus from "./pages/components/Menus";
import Pagination from "./pages/components/Pagination";
import Progress from "./pages/components/Progress";
import Snackbars from "./pages/components/Snackbars";
import Tooltips from "./pages/components/Tooltips";

// Form components
import SelectionCtrls from "./pages/forms/SelectionControls";
import Selects from "./pages/forms/Selects";
import TextFields from "./pages/forms/TextFields";

// Icon components
import MaterialIcons from "./pages/icons/MaterialIcons";

// Page components
import Blank from "./pages/pages/Blank";
import InvoiceDetails from "./pages/pages/InvoiceDetails";
import InvoiceList from "./pages/pages/InvoiceList";
import Orders from "./pages/pages/Orders";
import Pricing from "./pages/pages/Pricing";
import Settings from "./pages/pages/Settings";
import Projects from "./pages/pages/Projects";
import Chat from "./pages/pages/Chat";

// Table components
import SimpleTable from "./pages/tables/SimpleTable";
import MyTable from "./pages/tables/MyTable";
import AdvancedTable from "./pages/tables/AdvancedTable";

// Documentation
import Welcome from "./pages/docs/Welcome";
import GettingStarted from "./pages/docs/GettingStarted";
import Routing from "./pages/docs/Routing";
import Auth0 from "./pages/docs/auth/Auth0";
import Cognito from "./pages/docs/auth/Cognito";
import Firebase from "./pages/docs/auth/Firebase";
import JWT from "./pages/docs/auth/JWT";
import Guards from "./pages/docs/Guards";
import EnvironmentVariables from "./pages/docs/EnvironmentVariables";
import Deployment from "./pages/docs/Deployment";
import Theming from "./pages/docs/Theming";
import APICalls from "./pages/docs/APICalls";
import Redux from "./pages/docs/Redux";
import Internationalization from "./pages/docs/Internationalization";
import ESLintAndPrettier from "./pages/docs/ESLintAndPrettier";
import Support from "./pages/docs/Support";
import Changelog from "./pages/docs/Changelog";
import Agenzia from "./pages/pages/agenzie/Agenzie.js";

// Protected routes
import ProtectedPage from "./pages/protected/ProtectedPage";
import Users from "./pages/pages/Users";
import RCAuto from "./pages/pages/rcAuto";
import Services from "./pages/pages/services";
import Flotta from "./pages/pages/flotta";
import Flussi from "./pages/pages/flussi";
import Visure from "./pages/pages/visure";
import Visuredetails from "./pages/pages/visuredetails";
import LibriMatricola from "./pages/pages/libriMatricola";
import TestDynamic from "./pages/pages/testDynamic";
import Profile2 from "./pages/pages/profile2";
import LibriMatricolaDetails from "./pages/pages/libriMatricolaDetails/index.js";
import Fornitori from "./pages/pages/fornitori";
import AccordiDetails from "./pages/pages/accordiDetails";
import GestioneDocumenti from "./pages/pages/gestioneDocumenti";
import Accordi from "./pages/pages/accordi";
import CVT from "./pages/pages/cvt";
import CVTDetails from "./pages/pages/cvtDetails/index.js";
import RCAutoDetailsProfile from "./pages/pages/rcautoDetailsProfile2/index.js";
import Richieste from "./pages/pages/richieste/index.js";
import Avvisi from "./pages/pages/avvisi/index.js";
import FlotteDetails from "./pages/pages/flottaDetails/App.js";
import PreventivoExpress from "./pages/pages/preventivo-express/index.js";
import Progetti from "./pages/pages/progetti/index.js";
import AssStAxa from "./pages/pages/assStAxa/index.js";
import ClienteCRM from "./pages/pages/cliente/index.js";
import MeritX from "./pages/pages/meritx/index.js";
import Dealer from "./pages/pages/dealer/index.js";
import DealerAdminRates from "./pages/pages/dealer/admin/AdminRates";
import DealerAdminConditions from "./pages/pages/dealer/admin/AdminConditions";
import FinPolis from "./pages/pages/fin-polis-flow/Finpolis.js";
import SupportHub from "./pages/pages/supporthub/index.js";
import Documenti from "./pages/pages/documenti";
import TicketDetail from "./pages/pages/supporthub/pages/TicketDetail.js";
import Rinnovi from "./pages/pages/rinnovi/index.js";

// Dashboard components
const Default = async(() => import("./pages/dashboards/Default"));
const Analytics = async(() => import("./pages/dashboards/Analytics"));
const SaaS = async(() => import("./pages/dashboards/SaaS"));

// Form components
const Pickers = async(() => import("./pages/forms/Pickers"));
const Editors = async(() => import("./pages/forms/Editors"));
const Formik = async(() => import("./pages/forms/Formik"));

// Icon components
const FeatherIcons = async(() => import("./pages/icons/FeatherIcons"));
const Profile = async(() => import("./pages/pages/profile/index"));
const Tasks = async(() => import("./pages/pages/Tasks"));
const Calendar = async(() => import("./pages/pages/Calendar"));

// Table components
const DataGrid = async(() => import("./pages/tables/DataGrid"));

// Chart components
const Chartjs = async(() => import("./pages/charts/Chartjs"));
const ApexCharts = async(() => import("./pages/charts/ApexCharts"));

// Maps components
const GoogleMaps = async(() => import("./pages/maps/GoogleMaps"));
const VectorMaps = async(() => import("./pages/maps/VectorMaps"));

const routes = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <ProtectedPage />,
      },
    ],
  },
  {
    path: "dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "default",
        element: <Default />,
      },
      {
        path: "analytics",
        element: <Analytics />,
      },
      {
        path: "saas",
        element: <SaaS />,
      },
    ],
  },
  {
    path: "pages",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "profile",
        element: <Profile data />,
      },
      {
        path: "profile/:userId",
        element: <Profile data />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "pricing",
        element: <Pricing />,
      },
      {
        path: "chat",
        element: <Chat />,
      },
      {
        path: "blank",
        element: <Blank />,
      },
      {
        path: "users",
        element: <Users data />,
      },
      {
        path: "rcauto",
        element: <RCAuto />,
      },
      {
        path: "agenzie",
        element: <Agenzia />,
      },
      {
        path: "flotta",
        element: <Flotta />,
      },
      {
        path: "flussi",
        element: <Flussi />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "visure",
        element: <Visure />,
      },
      {
        path: "visuredetails/:idUID",
        element: <Visuredetails />,
      },
      {
        path: "libriMatricola",
        element: <LibriMatricola />,
      },
      {
        path: "libriMatricolaDetails/:idUID",
        element: <LibriMatricolaDetails />,
      },
      {
        path: "libriMatricolaDetails",
        element: <LibriMatricolaDetails />,
      },
      {
        path: "fornitori/:idUID",
        element: <Fornitori />,
      },
      {
        path: "fornitori",
        element: <Fornitori />,
      },
      {
        path: "accordiDetails",
        element: <AccordiDetails />,
      },
      {
        path: "accordiDetails/:idUID",
        element: <AccordiDetails />,
      },
      {
        path: "accordi",
        element: <Accordi />,
      },
      {
        path: "gestioneDocumenti",
        element: <GestioneDocumenti />,
      },
      {
        path: "documenti",
        element: <Documenti />,
      },
      {
        path: "testDynamic",
        element: <TestDynamic />,
      },
      {
        path: "profile2",
        element: <Profile2 />,
      },
      {
        path: "cvt",
        element: <CVT />,
      },
      {
        path: "cvtDetails",
        element: <CVTDetails />,
      },
      {
        path: "cvtDetails/:idUID",
        element: <CVTDetails />,
      },
      {
        path: "rcAutoDetails",
        element: <RCAutoDetailsProfile />,
      },
      {
        path: "rcAutoDetails/:idTarga",
        element: <RCAutoDetailsProfile />,
      },
      {
        path: "rcAutoDetails/:idTarga/:idUidPrev",
        element: <RCAutoDetailsProfile />,
      },
      {
        path: "richieste",
        element: <Richieste />,
      },
      {
        path: "avvisi",
        element: <Avvisi />,
      },
      {
        path: "flottaDetails",
        element: <FlotteDetails />,
      },
      {
        path: "flottaDetails?fileId=:fileId",
        element: <FlotteDetails />,
      },
      {
        path: "preventivo-express",
        element: <PreventivoExpress />,
      },
      {
        path: "progetti",
        element: <Progetti />,
      },
      {
        path: "assStAxa",
        element: <AssStAxa />,
      },
      {
        path: "cliente",
        element: <ClienteCRM />,
      },
      {
        path: "meritx",
        element: <MeritX />,
      },
      {
        path: "dealer",
        element: <Dealer />,
      },
      {
        path: "dealer/admin-rates",
        element: <DealerAdminRates />,
      },
      {
        path: "dealer/admin-conditions",
        element: <DealerAdminConditions />,
      },
      {
        path: "finpolis/*",
        element: <FinPolis />,
      },
      {
        path: "supporto",
        element: <SupportHub />,
      },
      {
        path: "supporto/:idUid",
        element: <TicketDetail />,
      },
      {
        path: "rinnovi",
        element: <Rinnovi />,
      },
    ],
  },
  {
    path: "projects",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Projects />,
      },
    ],
  },
  {
    path: "invoices",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <InvoiceList />,
      },
      {
        path: "detail",
        element: <InvoiceDetails />,
      },
    ],
  },
  {
    path: "orders",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Orders />,
      },
    ],
  },
  {
    path: "tasks",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Tasks />,
      },
    ],
  },
  {
    path: "calendar",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Calendar />,
      },
    ],
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "act-control",
        element: <ACTControl />,
      },
      {
        path: "act-control/:idUID",
        element: <ACTControl />,
      },
      {
        path: "reset",
        element: <ResetPassword />,
      },
      {
        path: "reset/password/:key",
        element: <InsertPassword />,
      },
      {
        path: "404",
        element: <Page404 />,
      },
      {
        path: "500",
        element: <Page500 />,
      },
    ],
  },
  {
    path: "public",
    element: <AuthLayout />,
    children: [
      {
        path: "operazione-successo",
        element: <OperationSuccess />,
      },
      {
        path: "operazione-fallita",
        element: <OperationFailed />,
      },
    ],
  },
  {
    path: "components",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "accordion",
        element: <Accordion />,
      },
      {
        path: "alerts",
        element: <Alerts />,
      },
      {
        path: "avatars",
        element: <Avatars />,
      },
      {
        path: "badges",
        element: <Badges />,
      },
      {
        path: "buttons",
        element: <Buttons />,
      },
      {
        path: "cards",
        element: <Cards />,
      },
      {
        path: "chips",
        element: <Chips />,
      },
      {
        path: "dialogs",
        element: <Dialogs />,
      },
      {
        path: "lists",
        element: <Lists />,
      },
      {
        path: "menus",
        element: <Menus />,
      },
      {
        path: "pagination",
        element: <Pagination />,
      },
      {
        path: "progress",
        element: <Progress />,
      },
      {
        path: "snackbars",
        element: <Snackbars />,
      },
      {
        path: "tooltips",
        element: <Tooltips />,
      },
    ],
  },
  {
    path: "forms",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "pickers",
        element: <Pickers />,
      },
      {
        path: "selection-controls",
        element: <SelectionCtrls />,
      },
      {
        path: "selects",
        element: <Selects />,
      },
      {
        path: "text-fields",
        element: <TextFields />,
      },
      {
        path: "editors",
        element: <Editors />,
      },
      {
        path: "formik",
        element: <Formik />,
      },
    ],
  },
  {
    path: "tables",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "simple-table-test",
        element: <MyTable />,
      },
      {
        path: "simple-table",
        element: <SimpleTable />,
      },
      {
        path: "advanced-table",
        element: <AdvancedTable />,
      },
      {
        path: "data-grid",
        element: <DataGrid />,
      },
    ],
  },
  {
    path: "icons",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "material-icons",
        element: <MaterialIcons />,
      },
      {
        path: "feather-icons",
        element: <FeatherIcons />,
      },
    ],
  },
  {
    path: "charts",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "chartjs",
        element: <Chartjs />,
      },
      {
        path: "apexcharts",
        element: <ApexCharts />,
      },
    ],
  },
  {
    path: "maps",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "google-maps",
        element: <GoogleMaps />,
      },
      {
        path: "vector-maps",
        element: <VectorMaps />,
      },
    ],
  },
  {
    path: "documentation",
    element: <DocLayout />,
    children: [
      {
        path: "welcome",
        element: <Welcome />,
      },
      {
        path: "getting-started",
        element: <GettingStarted />,
      },
      {
        path: "routing",
        element: <Routing />,
      },
      {
        path: "auth/auth0",
        element: <Auth0 />,
      },
      {
        path: "auth/cognito",
        element: <Cognito />,
      },
      {
        path: "auth/firebase",
        element: <Firebase />,
      },
      {
        path: "auth/jwt",
        element: <JWT />,
      },
      {
        path: "guards",
        element: <Guards />,
      },
      {
        path: "environment-variables",
        element: <EnvironmentVariables />,
      },
      {
        path: "deployment",
        element: <Deployment />,
      },
      {
        path: "theming",
        element: <Theming />,
      },
      {
        path: "api-calls",
        element: <APICalls />,
      },
      {
        path: "redux",
        element: <Redux />,
      },
      {
        path: "internationalization",
        element: <Internationalization />,
      },
      {
        path: "eslint-and-prettier",
        element: <ESLintAndPrettier />,
      },
      {
        path: "support",
        element: <Support />,
      },
    ],
  },
  {
    path: "changelog",
    element: <DocLayout />,
    children: [
      {
        path: "",
        element: <Changelog />,
      },
    ],
  },
  {
    path: "private",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <ProtectedPage />,
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
